import React from 'react';
import {LandingPagePropTypes, NeuroMessage} from '@ignitesales/neuro-application/src/neuro-guide';
import ReactSVG from "react-svg";

const LandingPage  = ({ componentClass, onStartGuideClick, isLoadingNextPage }) => {
  return (
    <>

      <div className={componentClass}>

        <div className={`${componentClass}__header`}>
          <ReactSVG src="/classpath/assets/images/icons/logo-wsfs.svg" />
        </div>

        <div className={`${componentClass}__content`}>
          <NeuroMessage id="landing.title" tagName='h1'/>
          <NeuroMessage id="landing.message" tagName="h2"/>
          <button onClick={() => onStartGuideClick()} disabled={isLoadingNextPage} className="btn btn-primary">
            <NeuroMessage id="landing.getStarted" />
          </button>
        </div>

        <div className={`${componentClass}__footer`}>
          © {new Date().getFullYear()} <NeuroMessage id="landing.footer" />
          <ReactSVG src="/classpath/assets/images/equal-housing-logo.svg" />
        </div>
      </div>
    </>
  );
};

LandingPage.propTypes = LandingPagePropTypes;

export default LandingPage;
